import React, { useState, useEffect, useRef } from "react";
import {
  View,
  ActivityIndicator,
  StyleSheet,
  FlatList,
  TouchableOpacity,
  RefreshControl,
  Platform,
} from "react-native";
import Colors from "../../../constants/Colors";
import GridTile from "../../../components/GridTile";
import { useSelector, useDispatch } from "react-redux";
import { HeaderButtons, Item } from "react-navigation-header-buttons";
import * as userNftActions from "../../../store/actions/userNft";
import GridTileThree from "../../../components/GridTileThree";
import DefaultText from "../../../components/text/DefaultText";
import CastButton from "../../../components/CastButton";
import MaterialButton from "../../../components/MaterialButton";

import AddArtworkScreen from "./AddArtworkScreen";
import CastDeviceModal from "../../../components/CastDeviceModal";

const ProfileUserScreen = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [isCasting, setIsCasting] = useState(false);
  const [checkboxDict, setCheckboxDict] = useState();
  const [isAllSelected, setIsAllSelected] = useState();
  const [socketMsg, setSocketMsg] = useState();
  let stopFetchMore = true;
  const dispatch = useDispatch();
  const modalizeRef = useRef(null);
  const onOpen = () => {
    modalizeRef.current?.open();
  };
  const onClose = () => {
    modalizeRef.current.close();
    setIsCasting(false);
    resetCheckBoxDict();
  };

  const userNfts = useSelector((state) => state.userNfts.myNfts);
  const socket = useSelector((state) => state.socket.io);
  const publicKeys = useSelector((state) => state.userNfts?.publicKeys);
  //console.log("publicKeys=" + publicKeys);
  //console.log(publicKeys[0]);
  let publicKey = publicKeys[0];
  // publicKeys == null || publicKeys.length == 0 ? null : publicKeys[0];

  // : Object.keys(publicKeys[0])[0];

  const numColumns = 3;
  let TouchableCmp = TouchableOpacity;
  if (Platform.OS === "android" && Platform.Version >= 21) {
    TouchableCmp = TouchableNativeFeedback;
  }
  const castSelectHandler = () => {
    //setIsCasting(true);
    if (isCasting) {
      resetCheckBoxDict();
    }
    setIsCasting((previousState) => !previousState);
    // uncheckAll();
  };
  React.useLayoutEffect(() => {
    props.navigation.setOptions({
      headerRight: () =>
        userNfts.length ? (
          <HeaderButtons HeaderButtonComponent={MaterialButton}>
            <Item
              title="Cast"
              iconName={"cast"}
              onPress={() => {
                castSelectHandler();
              }}
            />
          </HeaderButtons>
        ) : null,
      headerLeft: () => (
        <HeaderButtons HeaderButtonComponent={CastButton}>
          <Item
            title="Settings"
            iconName={"settings-outline"}
            onPress={() => props.navigation.navigate("ProfileSettingScreen")}
          />
        </HeaderButtons>
      ),
    });
  }, [props.navigation, userNfts]);
  const resetCheckBoxDict = () => {
    let dict = new Object();
    for (let i = 0; i < userNfts.length; i++) {
      dict[userNfts[i].id] = false;
    }
    setCheckboxDict(dict);
  };
  useEffect(() => {
    resetCheckBoxDict();
  }, [userNfts]);

  useEffect(() => {
    if (checkboxDict != null && checkboxDict.length != 0) {
      let temp = true;
      Object.keys(checkboxDict).forEach((key, index) => {
        temp = temp && checkboxDict[key];
      });
      setIsAllSelected(temp);
    }
  }, [checkboxDict]);

  const checkOne = (newValue, id) => {
    setCheckboxDict({ ...checkboxDict, [id]: newValue });
  };

  const checkAll = () => {
    let temp = new Object();
    Object.keys(checkboxDict).forEach((key, index) => {
      temp[key] = true;
    });

    setCheckboxDict(temp);
  };
  const uncheckAll = () => {
    resetCheckBoxDict();
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(userNftActions.fetchPublicKeys());
    dispatch(userNftActions.fetchNfts("ETHEREUM")).then(() => {
      setIsLoading(false);
    });
  }, [dispatch]);

  useEffect(() => {
    socket.on("chat message", (msg) => {
      setSocketMsg(msg);
    });
  });

  const formatData = (data, numColumns) => {
    let newData = [...data];
    const numberOfFullRows = Math.floor(data.length / numColumns);

    let numberOfElementsLastRow = data.length - numberOfFullRows * numColumns;
    while (
      numberOfElementsLastRow !== numColumns &&
      numberOfElementsLastRow !== 0
    ) {
      newData.push({ id: `blank-${numberOfElementsLastRow}`, empty: true });
      numberOfElementsLastRow++;
    }
    return newData;
  };

  if (isLoading) {
    return (
      <View style={styles.centered}>
        <ActivityIndicator size="large" color={Colors.primary} />
      </View>
    );
  }
  if (userNfts.length === 0) {
    return <AddArtworkScreen />;
  }

  const renderGridItem = (itemData) => {
    let title = itemData.item.title
      ? itemData.item.title
      : `#${itemData.item.tokenId}`;
    let id = itemData.item.id;

    return (
      <GridTileThree
        title={title}
        imageUrl={itemData.item.imageUrl}
        collectionImageUrl={itemData.item.collectionImageUrl}
        artist={itemData.item.artist}
        empty={itemData.item.empty}
        isCasting={isCasting}
        checkOne={() => {
          checkOne(!checkboxDict[id], id);
        }}
        isChecked={checkboxDict[id]}
        id={id}
        onSelect={() => {
          props.navigation.navigate("ProfileArtScreen", {
            itemId: id,
            from: "profile",
          });
        }}
      />
    );
  };

  const castHandler = () => {
    onOpen();
  };

  const onEndReached = () => {
    if (!stopFetchMore) {
      setLoadingMore(true);
      dispatch(
        userNftActions.fetchOpensea(publicKey, userNfts.length, "UPDATE")
      ).then(() => {
        setLoadingMore(false);
        stopFetchMore = true;
      });
    }
  };
  const onRefresh = () => {
    console.log("onRefresh");
    setRefreshing(true);

    dispatch(userNftActions.fetchOpensea(publicKey, 0, "SET")).then(() =>
      setRefreshing(false)
    );
  };
  return (
    <View style={styles.screen}>
      {refreshing && <ActivityIndicator size="small" color={Colors.primary} />}
      <FlatList
        keyExtractor={(item, index) => item.id}
        data={formatData(userNfts, numColumns)}
        renderItem={renderGridItem}
        numColumns={numColumns}
        style={styles.flatlistContainer}
        contentContainerStyle={{ paddingBottom: 120 }}
        onEndReached={onEndReached}
        onEndReachedThreshold={0.4}
        onScrollEndDrag={() => {
          stopFetchMore = false;
        }}
        ListFooterComponent={() =>
          loadingMore && (
            <ActivityIndicator size="small" color={Colors.primary} />
          )
        }
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
        }
      />

      {isCasting ? (
        <View style={styles.actionContainer}>
          <TouchableCmp style={styles.topActionButton} onPress={castHandler}>
            <DefaultText style={{ color: "black" }}>Start Casting</DefaultText>
          </TouchableCmp>
          <View style={styles.bottomActionContainer}>
            <TouchableCmp
              style={styles.bottomActionButton}
              onPress={castSelectHandler}
            >
              <DefaultText>Cancel</DefaultText>
            </TouchableCmp>
            {isAllSelected ? (
              <TouchableCmp
                style={styles.bottomActionButton}
                onPress={uncheckAll}
              >
                <DefaultText>Unselect All</DefaultText>
              </TouchableCmp>
            ) : (
              <TouchableCmp
                style={styles.bottomActionButton}
                onPress={checkAll}
              >
                <DefaultText>Select All</DefaultText>
              </TouchableCmp>
            )}
          </View>
        </View>
      ) : (
        <View />
      )}
      <CastDeviceModal
        modalizeRef={modalizeRef}
        onClose={onClose}
        castNFT={userNfts.filter((item, index) => checkboxDict[item.id])}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: "black",
  },
  castButton: {
    backgroundColor: Colors.primary,
    borderRadius: 40,
    padding: 15,
    position: "absolute",
    bottom: 50,
    right: 10,
  },
  actionContainer: {
    position: "absolute",
    bottom: 0,
    backgroundColor: Colors.background,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: 5,
  },
  topActionButton: {
    height: 42,
    width: "95%",
    backgroundColor: Colors.primary,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 11,
  },
  bottomActionContainer: {
    flexDirection: "row",
    width: "95%",
  },
  bottomActionButton: {
    borderColor: "white",
    backgroundColor: Colors.background,
    borderWidth: 1,
    marginHorizontal: "2.5%",
    width: "45%",
    height: 30,
    alignItems: "center",
    justifyContent: "center",
    marginVertical: 8,
  },
});

export default ProfileUserScreen;
